import { Stars } from "@mui/icons-material";
import {
  Badge,
  BadgeProps,
  IconButton,
  Tooltip,
  Typography,
  styled,
} from "@mui/material";
import { Box } from "@mui/system";
import ROLE from "enums/ROLE_NAME";
import { usePersistStore } from "hooks/useStore";
import colors from "theme/base/colors";
import RoleGuard from "./RoleGuard";

interface Props {
  isDisabled?: boolean;
  children: React.ReactNode;
  featureDetails?: {
    description: string;
    creationDate: Date;
  };
  allowedRoles?: ROLE[];
}

const StyledBadge = styled(Badge)<BadgeProps>(() => ({
  "& .MuiBadge-badge": {
    width: 1,
    backgroundColor: colors.white.main,
    right: 10,
    top: 10,
    padding: "0 4px",
  },
}));

const DAYS_UNTIL_OLD = 60;
const now: Date = new Date();

export default function MembersOnlyJacket({
  children,
  isDisabled,
  featureDetails,
  allowedRoles = [ROLE.SUPER_ADMIN, ROLE.SUPER_DUPER_ADMIN],
}: Props) {
  const { newFeaturesClicked, setValue } = usePersistStore() as {
    newFeaturesClicked: Array<string>;
    setValue: (key: string, value: unknown) => void;
  };
  const { description, creationDate } = featureDetails || {};

  const isClicked = description && newFeaturesClicked.includes(description);
  const isOld =
    creationDate &&
    new Date(creationDate).getTime() <
      now.getTime() - DAYS_UNTIL_OLD * 86400000;

  const acknowledgeFeature = (event) => {
    event.stopPropagation();
    setValue("newFeaturesClicked", [...newFeaturesClicked, description]);
  };

  return isDisabled ? (
    <></>
  ) : (
    <RoleGuard allowedRoles={allowedRoles}>
      {description && !isClicked && !isOld ? (
        <Tooltip
          title={
            <Typography variant="h6" sx={{ color: "white !important" }}>
              {description}
            </Typography>
          }
          onClick={acknowledgeFeature}
        >
          <StyledBadge
            badgeContent={
              <IconButton>
                <Stars color="warning" />
              </IconButton>
            }
          >
            <Box sx={{ opacity: 0.5 }} onMouseUp={acknowledgeFeature}>
              {children}
            </Box>
          </StyledBadge>
        </Tooltip>
      ) : (
        children
      )}
    </RoleGuard>
  );
}
